<template>
  <CustomPage
    title="我的红包"
    style="background: #f7f7f7"
    backRoute="Mine"
    rightText="领取红包"
    @onClickRight="$router.push({ name: 'RedpackCenter' })"
  >
    <div slot="content" style="height: 100%">
      <div class="redpack-container pt-3">
        <div
          class="flex flex-wrap justify-evenly text-center text-sm"
          style="height: 35px"
        >
          <div class="box-border w-1/3 flex justify-center">
            <div
              class="rounded-full font-light my-1 py-1"
              :class="{ active: status === true }"
              style="width: 12rem; background-color: #eeeeee"
              @click="status = true"
            >
              可使用{{ status ? '(' + redpackListLength + ')' : '' }}
            </div>
          </div>

          <div class="box-border w-1/3 flex justify-center">
            <div
              class="rounded-full font-light my-1 py-1"
              :class="{ active: status === false }"
              style="width: 12rem; background-color: #eeeeee"
              @click="status = false"
            >
              已过期{{ status ? '' : '(' + redpackListLength + ')' }}
            </div>
          </div>
        </div>

        <!-- //各种类型红包 -->
        <welfareTicketContent
          v-for="(value, keyVaule) in redpackList"
          :key="keyVaule"
          :type="keyVaule"
          :ticketArr="value"
        >
          <div slot="ticketContent">
            <div
              class="overflow-y-auto"
              style="max-height: calc(100vh - 120px)"
            >
              <div
                v-for="(item, index) in value[1]"
                :key="index"
                class="
              rounded-lg
              overflow-hidden
              lightshadow
              flex flex-row
              text-white
              items-center
              justify-between
              h-24
              ticketItemBottom
            "
                :style="{
                  backgroundColor:
                    status &&
                    (item.redPacketType === 'activity' ||
                      item.redPacketType === 'goods')
                      ? '#fff4f4'
                      : status && item.redPacketType === 'all'
                      ? '#FFDADA'
                      : status && item.redPacketType === 'store'
                      ? '#FFB8B8'
                      : '#efefef',
                }"
              >
                <div class="ticketItemLeft" style="width: 150px;">
                  <div style="display:flex;align-items:center">
                    <span class="text-xl moneySymbol">¥</span
                    ><span
                      class="leading-10 font-semibold"
                      style="letter-spacing: 0.1rem; font-size: 2.5rem"
                      >{{ item.reduceAmount }}</span
                    >
                  </div>
                  <div v-show="item.fullAmount" class="text-xs">
                    满{{ item.fullAmount }}元可用
                  </div>
                </div>
                <div class="text-left flex-grow ml-3">
                  <div class="text-black text-sm mb-1">
                    {{ item.title }}
                  </div>
                  <div class="text-xs">
                    {{ item.startDate }} - {{ item.endDate }}
                  </div>
                </div>
                <div v-if="status" class="ticketRight">
                  <div class="differentRangeTicket">
                    <span>{{
                      item.redPacketType === 'activity'
                        ? '活动红包'
                        : item.redPacketType === 'goods'
                        ? '商品红包'
                        : item.redPacketType === 'all'
                        ? '福利红包'
                        : item.redPacketType === 'store'
                        ? '店主红包'
                        : null
                    }}</span>
                  </div>

                  <Button
                    class="w-12 self-end"
                    style="
                padding-left: 6px;
                padding-right: 6px;
                margin-bottom: 0.75rem;
                margin-right: 0.75rem;
                white-space: nowrap;
              "
                    type="danger"
                    round
                    plain
                    size="mini"
                    @click="goUse(item)"
                    >去使用</Button
                  >
                </div>

                <img v-else :src="require('@/assets/redpack/yiguoqi.svg')" />
              </div>
            </div>
          </div>
        </welfareTicketContent>

        <Empty
          v-show="!Object.keys(redpackList).length"
          :image="require('@/assets/redpack/meiyouhongbao.svg')"
          description="暂无红包"
        />
        <Button
          v-if="!$store.state.user.distributionFlag"
          round
          style="
            background: linear-gradient(135deg, #e82237 0%, #ff9d9d 100%);
            width: 80%;
            margin: 0 10%;
          "
          size="large"
          @click="showCommand = true"
          ><span class="text-white">领取口令红包</span></Button
        >
        <Popup
          v-model="showCommand"
          class="w-64 text-center rounded lightshadow p-2"
        >
          <div>请输入店主分享给您的红包口令</div>
          <Field v-model="editingCommand" class="bg-f8" />
          <Button
            style="
              background: linear-gradient(135deg, #e82237 0%, #ff9d9d 100%);
              height: 40px;
            "
            size="large"
            @click="getCommand"
            ><span class="text-white">领取口令红包</span></Button
          >
        </Popup>
      </div>
    </div>
  </CustomPage>
</template>

<script>
import CustomPage from '@/components/custom-page.vue'
import { Button, Empty, Popup, Field, Toast } from 'vant'
import { getRedpackList, getStoreCommandRedpack } from './webApi'
import welfareTicketContent from '@/components/welfareTicketContent'
export default {
  components: { CustomPage, Button, Empty, Popup, Field, welfareTicketContent },
  created() {
    this.getMyRedpack()
  },

  data() {
    return {
      status: true,
      redpackList: {},
      showCommand: false,
      editingCommand: null,
      activityData: {},
      storeData: {},
      allPlatData: {},
    }
  },
  methods: {
    getMyRedpack() {
      getRedpackList(this.status).then(({ data }) => {

        console.log('getRedpackList', data)

        // const c = { all: [null, []], a1: ['img', []], a2: ['img', []] }
        const activityData = {}
        const storeData = {}
        const allPlatData = {}
        data.map((item) => {
          const activitylArr = []

          if (item.redPacketType === 'activity') {
            activitylArr[1] = item.myRedPackets
            activitylArr[0] = item.actBanner

            activityData[item.actName] = activitylArr
            this.activityData = activityData
          } else if (item.redPacketType === 'store') {
            activitylArr[1] = item.myRedPackets
            activitylArr[0] = item.storeImg

            storeData[item.storeName] = activitylArr
            this.storeData = storeData
          } else if (item.redPacketType === 'all') {
            activitylArr[1] = item.myRedPackets
            activitylArr[0] = null

            allPlatData.all = activitylArr
            this.allPlatData = allPlatData
          }
        })
        console.log(
          '----this.activityData----',
          this.activityData,
          '----this.storeData----',
          this.storeData,
          '----this.allPlatData----',
          this.allPlatData
        )

        this.redpackList = { ...activityData, ...storeData, ...allPlatData }
      })
    },
    getCommand() {
      if (!this.editingCommand) return
      getStoreCommandRedpack({
        command: this.editingCommand,
      }).then(
        (res) => {
          Toast({
            message: res.message,
            position: 'center',
            duration: 1000,
          })
          this.showCommand = false

          this.getMyRedpack()
        },
        (err) => {
          Toast({
            message: err.response.data.message,
            position: 'center',
            duration: 1000,
          })
        }
      )
    },
    goUse(item) {

      switch (item.redPacketType) {
        case 'activity':
          if (item.actId) {
            this.$router.push({
              name: 'ActivityPlace',
              params: { aid: item.actId },
            })
          } else {
            this.$router.push('/')
          }

          break

        case 'goods':
          this.$router.push({
            name: 'GoodsDetail',
            params: { id: item.partGoodsId },
          })
          break

        default:
          this.$router.push('/')
          break
      }
    },
  },
  watch: {
    status() {
      this.getMyRedpack()
    },
  },
  computed: {
    redpackListLength() {

      let sum = 0
      for (const item in this.redpackList) {
        if (this.redpackList[item][1]) {

          sum += this.redpackList[item][1].length
        }
      }
      return sum
    },
  },
}
</script>

<style lang="less" scoped>
.redpack-container {
  .active {
    background-color: #d8283b !important;
    color: #fff;
  }

  .ticketItemBottom {
    margin-bottom: 20px;
    padding-left: 40px;
    color: #e82035;
    &:nth-last-child(1) {
      margin-bottom: 0px;
    }

    .ticketItemLeft {
      .moneySymbol {
        margin-right: 4px;
      }
    }
    .ticketRight {
      height: 100%;
      .differentRangeTicket {
        width: 140px;
        height: 32px;
        background: #ffe3e6;
        border-radius: 0px 12px 0px 12px;
        margin-bottom: 16px;
        font-size: 22px;
        text-align: center;
      }
    }
  }
}
</style>
